import * as types from '../constants/ActionTypes';
import {loginUserFailure, loginUserThenRunFunc} from './auth';

export function fetchDataFailure(error) {
   console.error(error);

   if (error.response) {
      return {
         type: types.FETCH_DATA_FAILURE,
         payload: {
            status: error.response.status,
            statusText: error.response.statusText
         }
      }
   }

   return {
      type: types.FETCH_DATA_FAILURE,
      payload: {
         status: 909,
         statusText: error
      }
   }
}


export function fetchBooksDataRequest() {
   return {
      type: types.FETCH_BOOKS_DATA_REQUEST
   }
}

export function receiveBooksData(booksData) {
   return {
      type: types.RECEIVE_BOOKS_DATA,
      payload: {
         booksData: booksData
      }
   }
}

export function fetchBooksData(token) {
   return (dispatch, getState, jsonApi) => {
      var {conf, data} = getState();
      // Если данные уже выбирались - пропускаем новую выборку
      if (data.booksData) {
         return;
      }

      dispatch(fetchBooksDataRequest());
      return jsonApi.fetchData(token, conf.api.booksDataKey, conf.api.booksDataViewKey)
         .then(response => {
            dispatch(receiveBooksData(response));
         })
         .catch(error => {
            dispatch(fetchBooksDataFailure());
            if (error.response && error.response.status === 401) {
               dispatch(loginUserFailure(error));
            } else if (error.response && error.response.status === 403) {
               let login = conf.defUser.login;
               let pass = conf.defUser.pass;
               let savePass = false;
               const userCredentials = localStorage.getItem('userInfo');
               if (!!userCredentials && userCredentials !== '') {
                  const userCredentialsObj = JSON.parse(userCredentials);
                  login = userCredentialsObj.email;
                  pass = userCredentialsObj.password;
                  savePass = true;
               }
               //console.log('Re-loginUser-fetchBooksData', window.location.pathname);
               dispatch(loginUserThenRunFunc(login, pass, savePass, (newToken) => { dispatch(fetchBooksData(newToken)); }));
            } else {
               dispatch(fetchDataFailure(error));
            }
         })
   }
}

export function fetchBooksDataFailure() {
   return {
      type: types.FETCH_BOOKS_DATA_FAILURE
   }
}


export function fetchBookDataRequest() {
   return {
      type: types.FETCH_BOOK_DATA_REQUEST
   }
}

export function receiveBookData(newBookDataCache) {
   return {
      type: types.RECEIVE_BOOK_DATA,
      payload: {
         bookDataCache: newBookDataCache
      }
   }
}

export function fetchBookData(token, bookDataKey, articleDataKey) {
   return (dispatch, getState, jsonApi) => {
      let {conf, data} = getState();

      const _defineExtraParams = function (bookData) {
         let retValue = {};
         retValue.listLeafKeyToIndexMap = {};
         retValue.listLeafs = [];
         bookData.forEach((listItem, i) => {
            //if (!listItem.children) {
            if (!!listItem.articleKey) {
               retValue.listLeafKeyToIndexMap[listItem.articleKey] = i;
               retValue.listLeafs.push(i);
            }
         });
         if (!!articleDataKey) {
            retValue.currentArticleKey = articleDataKey;
         }else{
            retValue.currentArticleKey = Object.keys(retValue.listLeafKeyToIndexMap)[0];
         }

         return retValue;
      };

      // Если данные уже вибирались - пропускаем новую выборку
      if (data.bookDataCache && data.bookDataCache[bookDataKey]) {
         let bookDataFromCache = data.bookDataCache[bookDataKey];
         return Promise.resolve(bookDataFromCache).then(bookDataCache => {
            let bookData = bookDataCache.map(a => Object.assign({}, a));
            let extraParams = _defineExtraParams(bookData);
            dispatch(setBookData(bookDataKey, bookData, extraParams.listLeafs, extraParams.currentArticleKey, extraParams.listLeafKeyToIndexMap));
         });

      }else{
         dispatch(fetchBookDataRequest());
         return jsonApi.pressButton(token, bookDataKey, conf.api.filterButtonId)
            .then(function() { return jsonApi.fetchData(token, conf.api.booksDataKey, conf.api.bookDataViewKey);})
            .then(processingBookDataResponseNew)
            .then(response => {
               let bookData = response;
               let newBookData = {};
               newBookData[bookDataKey] = bookData;
               const newBookDataCache = Object.assign(newBookData, data.bookDataCache);
               dispatch(receiveBookData(newBookDataCache));
               let extraParams = _defineExtraParams(bookData);
               dispatch(setBookData(bookDataKey, bookData, extraParams.listLeafs, extraParams.currentArticleKey, extraParams.listLeafKeyToIndexMap));
            })
            .catch(error => {
               dispatch(fetchBookDataFailure());
               if (error.response && error.response.status === 401) {
                  dispatch(loginUserFailure(error));
               } else if (error.response && error.response.status === 403) {
                  let login = conf.defUser.login;
                  let pass = conf.defUser.pass;
                  let savePass = false;
                  const userCredentials = localStorage.getItem('userInfo');
                  if (!!userCredentials && userCredentials !== '') {
                     const userCredentialsObj = JSON.parse(userCredentials);
                     login = userCredentialsObj.email;
                     pass = userCredentialsObj.password;
                     savePass = true;
                  }
                  //console.log('Re-loginUser-fetchBookData', window.location.pathname);
                  dispatch(loginUserThenRunFunc(login, pass, savePass, (newToken) => { dispatch(fetchBookData(newToken, bookDataKey, articleDataKey)); }));
               } else {
                  dispatch(fetchDataFailure(error));
               }
            });
      }
   }
}

export function setBookData(bookDataKey, bookData, listLeafs, currentArticleKey, listLeafKeyToIndexMap) {
   return {
      type: types.SET_BOOK_DATA,
      payload: {
         currentBookKey: bookDataKey,
         bookData: bookData,
         listLeafs: listLeafs,
         currentArticleKey: currentArticleKey,
         listLeafKeyToIndexMap: listLeafKeyToIndexMap
      }
   }
}

export function setCurrentBookKey(currentBookKey) {
   return {
      type: types.SET_CURRENT_BOOK_KEY,
      payload: {
         currentBookKey: currentBookKey
      }
   }
}

export function fetchBookDataFailure() {
   return {
      type: types.FETCH_BOOK_DATA_FAILURE
   }
}


export function fetchArticleData(token, itemDataKey) {
   return (dispatch, getState, jsonApi) => {
      var {conf, data} = getState();
      // Если данные уже вибирались - пропускаем новую выборку
      if (data.articleDataCache && data.articleDataCache[itemDataKey]) {
         var articleData = Object.assign({}, data.articleDataCache[itemDataKey]);
         dispatch(setArticleData(articleData));
         return;
      }

      dispatch(fetchArticleDataRequest());
      return jsonApi.fetchData(token, itemDataKey)
         .then(response => {
            const articleData = response;
            let newArticleData = {};
            newArticleData[articleData.key] = articleData;
            const newArticleDataCache = Object.assign(newArticleData, data.articleDataCache);
            dispatch(receiveArticleData(newArticleDataCache));
            dispatch(setArticleData(articleData));
         })
         .catch(error => {
            dispatch(fetchArticleDataFailure());
            if (error.response && error.response.status === 401) {
               dispatch(loginUserFailure(error));
            } else if (error.response && error.response.status === 403) {
               let login = conf.defUser.login;
               let pass = conf.defUser.pass;
               let savePass = false;
               const userCredentials = localStorage.getItem('userInfo');
               if (!!userCredentials && userCredentials !== '') {
                  const userCredentialsObj = JSON.parse(userCredentials);
                  login = userCredentialsObj.email;
                  pass = userCredentialsObj.password;
                  savePass = true;
               }
               //console.log('Re-loginUser-fetchArticleData', window.location.pathname);
               dispatch(loginUserThenRunFunc(login, pass, savePass, (newToken) => { dispatch(fetchArticleData(newToken, itemDataKey)); }));
            } else {
               dispatch(fetchDataFailure(error));
            }
         })
   }
}

export function fetchArticleDataRequest() {
   return {
      type: types.FETCH_ARTICLE_DATA_REQUEST
   }
}

export function receiveArticleData(articleDataCache) {
   return {
      type: types.RECEIVE_ARTICLE_DATA,
      payload: {
         dataCache: articleDataCache
      }
   }
}

export function setArticleData(articleData) {
   return {
      type: types.SET_ARTICLE_DATA,
      payload: {
         articleData: articleData
      }
   }
}

export function setCurrentArticleKey(currentArticleKey) {
   return {
      type: types.SET_CURRENT_ARTICLE_KEY,
      payload: {
         currentArticleKey: currentArticleKey
      }
   }
}

export function fetchArticleDataFailure() {
   return {
      type: types.FETCH_ARTICLE_DATA_FAILURE
   }
}

// --------------------------------------------------------------

function processingBookDataResponseNew(response) {
   let json = [];
   const res = response.list["0"];

   let jsonItem0 = {};
   jsonItem0.depth = 0;
   jsonItem0.children = [];
   json.push(jsonItem0);
   let jsonItemIndex = 0;

   let jsonItem1 = {};
   jsonItem1.title = res.fields.custom_title;
   jsonItem1.depth = 1;
   jsonItem1.children = [];
   jsonItem1.parentIndex = jsonItemIndex;
   jsonItem1.articleKey = res.key;
   json.push(jsonItem1);
   jsonItemIndex++;

   let _printSubitems = function (subItems, parentItem, parentItemIndex) {
      if (!!subItems && subItems.length){
         for (let i = 0; i < subItems.length; i++) {
            const item = subItems[i];
            let jsonItem = {};
            jsonItem.title = item.fields.custom_title;
            jsonItem.depth = parentItem.depth + 1;

            if (!!item.subitems && item.subitems.length) {
               jsonItem.children = [];
            }

            jsonItem.parentIndex = parentItemIndex;
            jsonItem.articleKey = item.key;
            json.push(jsonItem);
            jsonItemIndex++;
            parentItem.children.push(jsonItemIndex);

            _printSubitems(subItems[i].subitems, jsonItem, jsonItemIndex);
         }
      }

   };

   _printSubitems(res.subitems, jsonItem1, jsonItemIndex);

   return json;
}


// WEBPACK FOOTER //
// ./src/actions/data.js